import React from "react";
import { OrgDiagram } from "basicprimitivesreact";
import {
  PageFitMode,
  Enabled,
  ChildrenPlacementType,
  GroupByType,
  leavesPlacementType,
  OrgItemConfig,
} from "basicprimitives";
import { Button, Avatar, IconButton, Grid } from "@mui/material";
import { useNavigate } from "react-router";

function TeamMemberOrgChart(props) {
  const navigate = useNavigate();
  var arr = [];
  props.TeamMembers.map((list) => {
    arr.push(
      new OrgItemConfig({
        id: list.id,
        parent: list.parent,
        title: list.lastName !== null && list.lastName !== "" ?list.firstName + " "+ list.lastName:list.firstName,
        description: list.jobTitleName,
        image: list.profilePhotoName,
        groupTitle: list.jobTitleName === "CEO" ? "CEO" : list.departmentCode,
        groupTitleColor: "#113776"
      })
    );
  });
  const config = {
    pageFitMode: PageFitMode.AutoSize,
    autoSizeMinimum: { width: 600, height: 20 },
    childrenPlacementType: ChildrenPlacementType.Horizontal,
    leavesPlacementType: ChildrenPlacementType.Vertical,
    // cursorItem: 1,
    // highlightItem: 0,
    hasSelectorCheckbox: Enabled.False,
    arrowsDirection: GroupByType.Children,
    items: arr,
  };
  const handleonCursorChanging = (event, data) => {
    const { context: item } = data;
    if (item != null) {
      navigate(`/users-profile/${item.id}`);
    }
  };
  return (
    <div className="App org-container">
      <OrgDiagram className="org-main"
        onCursorChanging={handleonCursorChanging}
        config={{
          ...config,
          defaultTemplateName: "defaultTemplate",
          templates: [
            {
              name: "defaultTemplate",
              autoSizeMinimum: { width: 600, height: 300 },
              itemSize: { width: 250, height: 77 },
              minimizedItemSize: { width: 20, height: 50 },
              // highlightPadding: { left: 20, top: 20, right: 20, bottom: 20 },
              onItemRender: ({ context: itemConfig }) => {
                return (
                  <div className="org-box"
                    style={{
                      border: "1px solid grey",
                      borderRadius: 5,
                      height: "auto",
                      padding: "3px",
                      background: "rgb(228, 238, 255)"
                    }}
                  >
                    <div
                      style={{
                        background: "#113776",
                        borderRadius: 2,
                        color: "white",
                        textTransform: "capitalize"
                      }}
                    >
                      {itemConfig.title}
                    </div>
                    <Grid container sx={{display: 'flex', alignItems: 'center', margin: '10px 0'}}>
                      <Grid item xs={2}>
                        <Avatar
                          sx={{
                            width: 25,
                            height: 25,
                            background: "#113776",
                            color: "#fff"
                          }}
                          src={`/api/uploads/image/show/${itemConfig.image}`}
                          alt={itemConfig.title.toUpperCase()}
                        />
                      </Grid>
                      <Grid item xs={10}>
                        <div style={{ wordBreak: "break-word" }}>
                          {itemConfig.description}
                        </div>
                        {/* <div style={{wordBreak:"break-all"}}>JuniorFullww Stack Developer</div> */}
                      </Grid>
                    </Grid>
                  </div>
                );
              },
            },
          ],
        }}
      />
    </div>
  );
}

export default TeamMemberOrgChart;
